import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackQuoteSubmittedParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/quote/trackQuoteSubmitted";
import { PartialSpecific } from "@store/Framework/Types/Common";

const useTrackQuoteSubmitted = (
    parameters: PartialSpecific<TrackQuoteSubmittedParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackQuoteSubmittedParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        cart: ga.use.cart(options, true),
        ...options,
    };

    return (parameters: Partial<TrackQuoteSubmittedParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.quoteSubmitted({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackQuoteSubmitted;
